import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import {
    animate,
    state,
    style,
    transition,
    trigger,
} from "@angular/animations";
import { DashboardBizzDevService } from "../../../shared/services/dashboard-bizz-dev.service";
import { ErrorLog } from "../../../shared/models/classes/Dashboard/errorLog";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
    selector: "app-error-log-monitoring",
    templateUrl: "./error-log-monitoring.component.html",
    styleUrls: ["./error-log-monitoring.component.scss"],
    animations: [
        trigger("detailExpand", [
            state(
                "collapsed, void",
                style({
                    height: "0px",
                    visibility: "hidden",
                })
            ),
            state(
                "expanded",
                style({
                    "min-height": "48px",
                    height: "*",
                    visibility: "visible",
                })
            ),
            transition(
                "expanded <=> collapsed, void <=> *",
                animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
            ),
        ]),
    ],
})
export class ErrorLogMonitoringComponent implements OnInit {
    displayedColumns = ["procedureName", "_InsertTimeSpan", "checked"];
    dataSource;
    expandedElement: ErrorLog | null;
    @ViewChild(MatSort)
    sort: MatSort;

    constructor(
        private dashboardService: DashboardBizzDevService,
        private formBuilder: FormBuilder
    ) {}

    dateForm: FormGroup = this.formBuilder.group({
        minDate: [null, Validators.required],
        maxDate: [null, Validators.required],
    });
    ngOnInit(): void {
        this.GetErrorsLog();
    }
    get getFormControls() {
        return this.dateForm.controls;
    }
    GetErrorsLog() {
        this.dashboardService
            .getErrorLog(
                new Date(this.getFormControls.minDate.value),
                new Date(this.getFormControls.maxDate.value)
            )
            .subscribe((value) => {
                this.dataSource = new MatTableDataSource(value);
                if (this.sort) {
                    this.dataSource.sort = this.sort;
                }
            });
    }
    initErrorLog() {
        this.dashboardService
            .getErrorLog(
                new Date(this.getFormControls.minDate.value),
                new Date(this.getFormControls.maxDate.value)
            )
            .subscribe((value) => {
                this.dataSource = new MatTableDataSource(value);
                if (this.sort) {
                    this.dataSource.sort = this.sort;
                }
            });
    }
    errorHasBeenChecked(id: number) {
        this.dashboardService.setErrorCheckedState(id).subscribe();
        this.deleteRow(id);
    }
    deleteRow(id: number) {
        if (id > -1) {
            this.dataSource.data = this.dataSource.data.filter(
                (item) => item.id !== id
            );
        }
    }
}
